<template>
  <div class="app-container schools-admin-page">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SchoolsAdminPageFrame'
}
</script>
